export default __webpack_public_path__ + "static/media/daedarus.42866bf0.png";